import React from 'react';
import { map, sum, capitalize } from 'lodash';
import AbsoluteValue from '../../../common/AbsoluteValue';
import { splitByThousands, percentageValue } from '../../../../helpers/NumberFormatter';

export const rollingMonthRevenueSettings = {
	settingsForTable,
	settingsForRow
};


function settingsForTable(){
	let columns = [

	   {
		   id: 'month_label',
		   className: 'table-text-left', 
		   headerClassName: 'table-text-left',
		   Header: 'Month',
		   accessor: 'month_label',
		   // Cell: props => <span>{capitalize(props.value)}</span>,
	   },
	   {
		   id: 'dig_income_r12',
		   className: 'table-text-right', 
		   headerClassName: 'table-text-right',
		   Header: 'Digital Income',
		   // width: 40,
		   accessor: 'dig_income_r12',
		   Cell: props => <span>{splitByThousands(props.value, '$')}</span>,
	   },
	   {
			id: 'phy_income_r12',
			className: 'table-text-right', 
			headerClassName: 'table-text-right',
			Header: 'Physical Income',
			// width: 40,
			accessor: 'phy_income_r12',
			Cell: props => <span>{splitByThousands(props.value, '$')}</span>,
	   },
	   {
			id: 'nr_income_r12',
			className: 'table-text-right', 
			headerClassName: 'table-text-right',
			Header: 'NR Income',
			// width: 40,
			accessor: 'nr_income_r12',
			Cell: props => <span>{splitByThousands(props.value, '$')}</span>,
	   },
	   {
			id: 'total_income_r12',
			className: 'table-text-right', 
			headerClassName: 'table-text-right',
			Header: 'Total Income',
			// width: 40,
			accessor: 'total_income_r12',
			Cell: props => <span>{splitByThousands(props.value, '$')}</span>,
		},
	 


	];
	return columns;
}

function settingsForRow(state, rowInfo, column) {
	if(rowInfo===undefined)
		return {};
	return {
		className: `color_index_${rowInfo.original.colorIndex}`
	}
}